/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import PersonalisedTab from './PersonalisedTab'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { useDispatch, useSelector } from 'react-redux'
import { fetchFeedback } from '../../redux/personaliseLessons/feedbackSlice'
import { fetchCourseModule, selectCourseModule, selectCourseModuleContent } from '../../redux/personaliseLessons/courseModuleSlice'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import { fetchLessonQuiz } from '../../redux/personaliseLessons/lessonQuizSlice'
import { BarLoader, ClipLoader, SyncLoader } from 'react-spinners'
import { fetchLessonDetails, selectLessonDetails } from '../../redux/personaliseLessons/lessonDetailsSlice'
import { fetchUserActivityUpdate } from '../../redux/personaliseLessons/updateUserActivitySlice'
import { fetchModuleProgress } from '../../redux/personaliseLessons/moduleProgressSlice'
import { selectAuthentication } from '../../redux/personaliseLessons/authenticationSlice'
import { selectCourseList } from '../../redux/personaliseLessons/courseListSlice'
import { Mixpanel } from '../../config/Mixpanel'
import constants, { removeWords } from './utilities/constants'
import { fetchKeyTakeaways } from '../../redux/personaliseLessons/keyTakeawaySlice'
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'
import { darcula } from 'react-syntax-highlighter/dist/esm/styles/prism'

const QuizSection = ({
    userGoal,
    setUserGoal,
    course_slug,
    lesson_slug,
    module_slug,
    moduleName,
}) => {

    const courseModule = useSelector(selectCourseModule)
    const courseModuleContent = useSelector(selectCourseModuleContent)
    const lessonDetails = useSelector(selectLessonDetails)?.lesson_data

    const existingUserGoal = courseModule?.user_goal
    const lesson_name = lessonDetails?.lesson_name
    const videoId = lessonDetails?.video_url?.split("?")?.[1]?.split("=")?.[1]
    const lessonId = lessonDetails?.lesson_id
    const content = lessonDetails?.resource?.content
    const contentType = lessonDetails?.resource?.type
    const language = lessonDetails?.resource?.language

    const codeExists = contentType === 'code'
    const textExists = contentType === 'text'

    const [moduleIndex, setModuleIndex] = useState(0)
    const [lessonIndex, setLessonIndex] = useState(0)
    const [feedback, setFeedback] = useState(lessonDetails?.quiz_analysis)
    const [feedbackArray, setfeedbackArray] = useState([])
    const [feedbackPoints, setFeedbackPoints] = useState([])
    const [answer, setAnswer] = useState(lessonDetails?.quiz_answer)
    const [navigationArray, setNavigationArray] = useState([])
    const [isQuizLoading, setIsQuizLoading] = useState(false)
    const [isAnalysisLoading, setIsAnalysisLoading] = useState(false)

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const uid = useSelector(selectAuthentication)?.uid
    const subject_name = useSelector(selectCourseList)?.courseName

    useEffect(() => {
        let navigateArray = []
        for (let i = 0; i < courseModuleContent?.length; i++) {
            for (let j = 0; j < courseModuleContent?.[i]?.module_content?.length; j++) {
                navigateArray.push(`/personalise/${encodeURIComponent(course_slug)}/${encodeURIComponent(courseModuleContent?.[i]?.module_slug)}/${encodeURIComponent(courseModuleContent?.[i]?.module_content?.[j]?.lesson_slug)}`)
            }
        }
        setNavigationArray(navigateArray)
    }, [])

    useEffect(() => {
        if (existingUserGoal?.length > 0 && lessonDetails?.quiz_question?.length === 0) {
            setIsQuizLoading(true)
            const fetchData = async () => {
                setIsQuizLoading(true)
                try {
                    await dispatch(fetchLessonQuiz({
                        user_id: uid,
                        video_id: videoId,
                        subject: subject_name,
                        lesson_id: lessonId,
                        goal: existingUserGoal,
                        skill: lesson_name
                    }))
                    await dispatch(fetchLessonDetails({
                        uid: uid,
                        subject: subject_name,
                        lesson_slug: lesson_slug
                    }))
                    setIsQuizLoading(false)
                } catch (err) {
                    setIsQuizLoading(false)
                    console.log(err.message);
                }
            }
            fetchData()
        }
    }, [lesson_slug, lessonDetails?.quiz_question?.length])

    useEffect(() => {
        setModuleIndex(courseModuleContent?.findIndex((item) => item?.module_slug === module_slug))
    }, [module_slug])

    useEffect(() => {
        setLessonIndex(courseModuleContent?.[moduleIndex]?.module_content?.findIndex((item) => item?.lesson_slug === lesson_slug))
    }, [moduleIndex, lesson_slug])

    useEffect(() => {
        setAnswer(lessonDetails?.quiz_answer)
        setFeedback(lessonDetails?.quiz_analysis)
    }, [lessonDetails])

    useEffect(() => {
        setfeedbackArray(feedback?.feedback ? feedback?.feedback?.split("\n\n") : feedback?.split('\n\n'))
    }, [feedback])

    const extractFeedback = (feedbackArray) => {

        const feedbackPoints = []
        feedbackArray?.forEach((feedback) => {
            console.log('after puja2', feedback)
            feedbackPoints.push(...feedback?.split('\n'))
        })
        return feedbackPoints
    }

    useEffect(() => {
        if (feedbackArray) setFeedbackPoints(extractFeedback(feedbackArray))
    }, [feedbackArray])

    const handleSubmit = (e) => {
        e.preventDefault()
        Mixpanel.track(constants.Mixpanel.LESSON_PAGE_USER_GOAL_FROM_QUIZ_WAS_CLICKED)
        if (userGoal.length <= 0) {
            return toast.error("Enter your goal")
        }
        const fetchData = async () => {
            setIsQuizLoading(true)
            try {

                await dispatch(fetchLessonQuiz({
                    user_id: uid,
                    video_id: videoId,
                    subject: subject_name,
                    lesson_id: lessonId,
                    goal: userGoal,
                    skill: lesson_name
                }))

                await dispatch(fetchKeyTakeaways({
                    user_id: uid,
                    video_id: videoId,
                    goal: userGoal,
                    skill: lesson_name,
                    lesson_id: lessonId,
                    subject: subject_name
                }));

                await dispatch(fetchCourseModule({
                    uid: uid,
                    subject_name: course_slug
                }));

                await dispatch(fetchLessonDetails({
                    uid: uid,
                    subject: subject_name,
                    lesson_slug: lesson_slug
                }))

                setIsQuizLoading(false)
            } catch (error) {
                // Handle any errors that may occur during the dispatch
                console.error("Error:", error);
            }
        };
        fetchData();
        setUserGoal('')
    }

    const handleQuizSubmit = (e) => {
        e.preventDefault()
        Mixpanel.track(constants.Mixpanel.LESSON_PAGE_QUIZ_WAS_SUBMITTED)
        if (answer.length <= 0) {
            return toast.error("Enter your answer")
        }
        const fetchData = async () => {
            setIsAnalysisLoading(true)
            try {
                await dispatch(fetchFeedback({
                    user_id: uid,
                    subject: subject_name,
                    video_id: videoId,
                    lesson_id: lessonId,
                    goal: existingUserGoal,
                    skill: lesson_name,
                    question: lessonDetails?.quiz_question,
                    answer: answer
                }))

                await dispatch(fetchUserActivityUpdate({
                    uid: uid,
                    subject: subject_name,
                    lesson_id: lessonDetails?.lesson_id,
                    status: "completed"
                }))

                await dispatch(fetchModuleProgress({
                    uid: uid,
                    subject_name: subject_name,
                    module_name: moduleName
                }))

                dispatch(fetchLessonDetails({
                    lesson_slug: lesson_slug,
                    subject: subject_name,
                    uid: uid
                }))
                dispatch(fetchCourseModule({ uid: uid, subject_name }))
                setIsAnalysisLoading(false)
            } catch (error) {
                console.log(error.message);
            }
        }
        fetchData()
    }

    const handlePreviousLesson = () => {
        Mixpanel.track(constants.Mixpanel.LESSON_PAGE_PREVIOUS_LESSON_BUTTON_CLICKED)
        let index = navigationArray?.findIndex((item) => item === `/personalise/${encodeURIComponent(course_slug)}/${encodeURIComponent(module_slug)}/${encodeURIComponent(lesson_slug)}`)
        navigate(navigationArray[index - 1])
    }

    const handleNextLesson = () => {
        Mixpanel.track(constants.Mixpanel.LESSON_PAGE_NEXT_LESSON_BUTTON_CLICKED)
        let index = navigationArray?.findIndex((item) => item === `/personalise/${encodeURIComponent(course_slug)}/${encodeURIComponent(module_slug)}/${encodeURIComponent(lesson_slug)}`)
        navigate(navigationArray[index + 1])

    }

    const parseQuestionWithCodeBlocks = (text) => {
        if (!text) return null;

        const parts = text.split('```');

        return parts.map((part, index) => {
            if (index % 2 === 0) {
                return part ? <span key={index}>{part}</span> : null;
            } else {
                const lines = part.split('\n');
                const firstLine = lines[0].trim();
                const hasLanguage = firstLine && !firstLine.includes(' ');

                let codeContent;
                if (hasLanguage) {
                    // Remove language line and trim empty lines
                    const codeLines = lines.slice(1);
                    // Remove leading empty lines
                    while (codeLines.length > 0 && codeLines[0].trim() === '') {
                        codeLines.shift();
                    }
                    // Remove trailing empty lines  
                    while (codeLines.length > 0 && codeLines[codeLines.length - 1].trim() === '') {
                        codeLines.pop();
                    }
                    codeContent = codeLines.join('\n');
                } else {
                    codeContent = part.trim();
                }

                return (
                    <SyntaxHighlighter
                        language={removeWords(subject_name).toLowerCase()}
                        style={darcula}
                        wrapLongLines={true}
                        customStyle={{
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-word',
                            overflowWrap: 'break-word',
                            overflowX: 'hidden',
                            padding: '12px',
                            borderRadius: '12px',
                            marginTop: '12px',
                        }}
                        codeTagProps={{
                            style: {
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'break-word',
                                overflowWrap: 'break-word',
                            },
                        }}
                    >
                        {codeContent}
                    </SyntaxHighlighter>
                );
            }
        }).filter(Boolean);
    };

    return (
        <>
            {!existingUserGoal?.length > 0 ? (
                !isQuizLoading ? <div className='p-4 reactour-desktop-usergoal'>
                    <div className=''>
                        <h2 className='text-2xl font-semibold'>Quiz Question</h2>
                        <p className='italic w-[95%] opacity-50 text-sm mt-2 leading-[17px]'>Provide us your goal and we’ll personalise quiz for you</p>
                    </div>
                    <div className='bg-[#2D4F71] rounded-xl px-4 py-5 mt-2'>
                        <p>With this course, I want to _______</p>
                        <form onSubmit={handleSubmit}>
                            <input
                                type="text"
                                placeholder='Get a job as a data scientist, get a raise of...'
                                value={userGoal}
                                onChange={(e) => setUserGoal(e.target.value)}
                                className='w-full bg-[#17395A] rounded-xl text-sm goal border-none placeholder:text-sm mt-2'
                            />
                            <div className='flex justify-end mt-4 mb-1'>
                                <button type='submit' disabled={!userGoal.length > 0} className='py-2 disabled:opacity-50 cursor-pointer px-5 rounded-xl bg-[#7FC241]'>Submit</button>
                            </div>
                        </form>
                    </div>
                </div> : <div className='h-[200px] mt-4 rounded-xl lg:my-6 mx-4 mb-2 bg-[#2D4F71] flex flex-col items-center justify-center'>
                    <p className='mb-2'>Loading</p>
                    <BarLoader color='#7FC241' />
                </div>) :
                (!isQuizLoading ? <div className='p-4 reactour-quizsection'>
                    <div className='relative'>
                        <h2 className='text-2xl font-semibold'>Quiz</h2>
                        <p className='italic w-[95%] opacity-50 text-sm mt-1 leading-[17px]'>Complete quiz to mark this lesson as complete</p>
                        <PersonalisedTab />
                    </div>
                    <div className='mt-4 leading-[19px]'>
                        {parseQuestionWithCodeBlocks(lessonDetails?.quiz_question)}
                        {codeExists ? <SyntaxHighlighter
                            language={language || removeWords(subject_name).toLowerCase()}
                            style={darcula}
                            wrapLongLines={true}
                            customStyle={{
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'break-word',
                                overflowWrap: 'break-word',
                                overflowX: 'hidden',
                                padding: '12px',
                                borderRadius: '12px',
                                marginTop: '12px',
                                marginBottom: 0,
                            }}
                            codeTagProps={{
                                style: {
                                    whiteSpace: 'pre-wrap',
                                    wordBreak: 'break-word',
                                    overflowWrap: 'break-word',
                                },
                            }}
                        >
                            {content}
                        </SyntaxHighlighter> : null}
                        {textExists ? <p className='mt-4 text-white/80 leading-[140%] bg-[#2D4F71]/20 rounded-xl p-4'>{content}</p> : null}
                        <form onSubmit={handleQuizSubmit}>
                            <textarea
                                id='answer'
                                value={answer}
                                onChange={(e) => setAnswer(e.target.value)}
                                placeholder='Answer this question in 2-3 lines'
                                className='w-full rounded-xl bg-[#2D4F71] h-28 mt-4 answer_text'
                            />
                            {!isAnalysisLoading ? <button type='submit' disabled={!answer} className='py-3.5 disabled:opacity-50 w-2/5 mt-2 rounded-xl bg-[#7FC241] font-semibold cursor-pointer'>{!feedback?.length > 0 ? 'Submit' : 'Resubmit'}</button> :
                                <button type='submit' disabled={isAnalysisLoading} className='flex items-center justify-center py-3.5 disabled:opacity-50 w-2/5 mt-2 font-semibold rounded-xl bg-[#7FC241]'>Analysing <ClipLoader color='white' size={15} className='ml-2' /></button>}
                        </form>
                    </div>
                    {feedback?.length > 0 ? <div className='mt-4'>
                        <h2 className='text-xl font-semibold'>Your Feedback</h2>
                        <div className='bg-[#639DD4] rounded-xl p-4 leading-[19px] mt-2'>
                            {feedbackPoints?.map((item, index) => (
                                <p className='mt-2' key={index}>{item}</p>
                            ))}
                        </div>
                    </div> : null}
                </div> : <div className='h-[200px] mt-4 rounded-xl lg:my-6 mx-4 mb-2 bg-[#2D4F71] flex flex-col items-center justify-center'>
                    <p className='mb-2'>Loading</p>
                    <SyncLoader color='#7FC241' />
                </div>)}
            <div className={`px-4 mt-1 flex ${!(moduleIndex === 0 && lessonIndex === 0) ? 'justify-between' : 'justify-end'}`}>
                {!(moduleIndex === 0 && lessonIndex === 0) && <div className='flex items-center cursor-pointer' onClick={handlePreviousLesson}>
                    <FontAwesomeIcon icon={faArrowLeft} />
                    <p className='ml-1 font-semibold'>Previous Lesson</p>
                </div>}
                {!(moduleIndex === courseModuleContent?.length - 1 && lessonIndex === courseModuleContent?.[moduleIndex]?.module_content?.length - 1) && <div className={`flex items-center cursor-pointer ${feedback?.length > 0 ? 'bg-[#7FC241] pl-2.5 pr-3 py-2 rounded-xl' : ''}`} onClick={handleNextLesson}>
                    <p className={`${feedback?.length > 0 ? 'mr-2' : 'mr-1'} font-semibold`}>Next Lesson</p>
                    <FontAwesomeIcon icon={faArrowRight} className='arrow-move' />
                </div>}
            </div>
        </>
    )
}

export default QuizSection